import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ActivityModel, Category, ComboCard } from '@/core/interfaces';

interface CategoriesState {
	categories: Category[];
	comboCards: ComboCard[];
	rewardCollected: boolean;
	canClaimReward: boolean;
	showDrawerFoundDailyCombo: boolean;
	dailyComboRewards: number;
	uploadedActivity: boolean;
}

const categoriesSlice = createSlice({
	name: 'categories',
	initialState: {
		categories: [],
		comboCards: [],
		rewardCollected: false,
		canClaimReward: false,
		showDrawerFoundDailyCombo: false,
		dailyComboRewards: 5000000,
		uploadedActivity: false,
	} as CategoriesState,
	reducers: {
		setCategories: (state, action) => {
			state.categories = action.payload;
		},
		setComboCards: (state, action) => {
			state.comboCards = action.payload.comboCards;

			if (state.comboCards.length === 3 && !state.rewardCollected) {
				state.canClaimReward = true;
			}
		},
		setRewardCollected: (state, action) => {
			state.rewardCollected = action.payload;
		},
		setCanClaim: (state, action) => {
			state.canClaimReward = action.payload;
		},
		upgradeActivity: (
			state,
			action: PayloadAction<{ card: ActivityModel }>
		) => {
			const { card } = action.payload;

			const category = state.categories.find(
				(cat) => cat.id === card.category
			);
			if (category) {
				const activityIndex = category.activities.findIndex(
					(act) => act.id === card.id
				);

				if (activityIndex !== -1) {
					category.activities[activityIndex] = {
						...category.activities[activityIndex],
						...card,
					};
				}
			}
			state.uploadedActivity = true;
		},
		decrementCountdownActivities: (state) => {
			state.categories.map((category) => {
				category.activities.map((activity) => {
					if (activity.userInfo) {
						if (activity.userInfo.timerRemainingSeconds > 0) {
							activity.userInfo.timerRemainingSeconds -= 1;
						}
					}
				});
			});
		},
		setShowDrawerDailyComboFound: (state, action) => {
			state.showDrawerFoundDailyCombo = action.payload;
		},
		setUploadActivity: (state, action) => {
			state.uploadedActivity = action.payload;
		},
	},
});

const { reducer, actions } = categoriesSlice;

export const {
	setCategories,
	upgradeActivity,
	setComboCards,
	setRewardCollected,
	setShowDrawerDailyComboFound,
	setCanClaim,
	setUploadActivity,
	decrementCountdownActivities,
} = actions;
export default reducer;
